import { IContentFilmList } from "src/lib/types/ContentFilmList";
import Head from 'next/head';

//#region [Props]
type ContentFilmListSeoProps = {
    contentFilmList: IContentFilmList<true>;
};
//#endregion

//#region [Component]
export default function ContentFilmListSeo({ contentFilmList }: ContentFilmListSeoProps) {
    return <Head>
        <title key="title">{`${contentFilmList.seoTitle ?? contentFilmList.title} - Filmweb`}</title>
    </Head>;
}
//#endregion

//#region [Styles]

//#endregion